import Model, { attr } from '@ember-data/model';

export default class VisitorsConfiguration extends Model {
  @attr('boolean') declare employeeSignOutDisabled: boolean;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'visitors-configuration': VisitorsConfiguration;
  }
}
